// Auth0's GenericError sets .error to a string code identifying the failure.
// We treat both `login_required` (no/expired session) and `interaction_required`
// (silent flow needs UI) the same: redirect the user to log in. Other codes
// (`mfa_required`, etc.) are out of scope and are re-thrown by callers.
export function isReauthRequired(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  const code = (error as { error?: string }).error;

  return code === 'login_required' || code === 'interaction_required';
}
